import React from 'react';
import { GameState, Player } from '../../../../../services/api';
import UpdatablePlayersList from '../../../../Common/UpdatablePlayersList';
import SituationPanel from '../../../../Common/SituationPanel';
import ActionButton from '../../../../Common/ActionButton';
import { useTranslation } from 'react-i18next';

interface SituationPlayerViewProps {
  gameState: GameState;
  currentPlayerOrder: Player[];
  onOrderChange: (orderedPlayers: Player[]) => void;
  onRevealAnswers: () => void;
  onNextRound: () => void;
  isLoading: boolean;
}

const SituationPlayerView: React.FC<SituationPlayerViewProps> = ({
  gameState,
  currentPlayerOrder,
  onOrderChange,
  onRevealAnswers,
  onNextRound,
  isLoading
}) => {
  const { t } = useTranslation();
  return (
    <div className="space-y-6">
      <SituationPanel 
        situation={gameState.currentSituation}
        variant="compact"
      />

      <UpdatablePlayersList
        players={currentPlayerOrder}
        onOrderChange={gameState.state === 'results' ? () => {} : onOrderChange}
        title={gameState.state === 'results' ? "Your Guesses" : "Order Players from Lowest to Highest"}
        instructions={gameState.state === 'results' 
          ? "Here's how you ordered the players with their actual numbers:" 
          : `Drag and drop players to order them from 1 (lowest reaction) to ${currentPlayerOrder.length} (highest reaction). The position in the list determines their number!`}
        showChangeIndicator={false}
        disabled={gameState.state === 'results'}
        results={gameState.state === 'results' ? gameState.results : undefined}
      />

      {gameState.state === 'results' && gameState.scoreResult && (
        <div className="bg-green-50 border-2 border-green-200 rounded-xl p-4 text-center space-y-2">
          <p className="text-lg font-bold text-green-800">
            {t('game.yourScore')} {gameState.scoreResult.score} / {gameState.scoreResult.totalPlayers}
          </p>
        </div>
      )}

      <div className="flex justify-center">
        {gameState.state === 'guessing' ? (
          <ActionButton
            onClick={onRevealAnswers}
            loading={isLoading}
            variant="danger"
            size="lg"
          >
            {t('game.revealAnswersButton')}
          </ActionButton>
        ) : (
          <ActionButton
            onClick={onNextRound}
            loading={isLoading}
            variant="secondary"
            size="lg"
          >
            {t('game.continueToNextRound')}
          </ActionButton>
        )}
      </div>
    </div>
  );
};

export default SituationPlayerView;